var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSun = function SvgSun(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    width: 24,
    height: 24,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2v2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20v2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.93 4.93l1.41 1.41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.66 17.66l1.41 1.41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12h2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20 12h2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M4.93 19.07l1.41-1.41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.66 6.34l1.41-1.41"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSun);
export { ForwardRef as ReactComponent };